// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyAP0_CPR1kdY0i-tqczHEZd1zP4wpuMeqw',
  authDomain: 'myco-tech.firebaseapp.com',
  projectId: 'myco-tech',
  storageBucket: 'myco-tech.appspot.com',
  messagingSenderId: '536216014095',
  appId: '1:536216014095:web:5d4b496449c896e71a827a',
};

const app = initializeApp(firebaseConfig);

// Core exports
export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

googleProvider.setCustomParameters({
  prompt: "select_account",
});

// Messaging setup
const messagingSupported = await isSupported().catch(() => false);
export const messaging = messagingSupported ? getMessaging(app) : null;

// Detect local timezone once
const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

// Request permission to show notifications and save the token + tz
export const requestPermission = async (uid) => {
  if (!messaging || !uid) return; // need supported browser + real user id

  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return;

    const currentToken = await getToken(messaging, {
      vapidKey:
        'BGPs2pBE-fcXWpkVqRXs_UaGh7I7xXyrdvU9oQ2hFXCVexq9k1jz8Vg65cZgqJrrbVoGlIVD_iGx-PbK1P10u1Y',
    });
    if (!currentToken) return;

    // avoid re-registering if unchanged
    const prev = localStorage.getItem('fcmToken');
    if (prev !== currentToken) {
      localStorage.setItem('fcmToken', currentToken);

      await fetch(
        'https://us-central1-myco-tech.cloudfunctions.net/registerToken',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ userId: uid, token: currentToken, tz }),
        }
      );
    }

    console.log('🎯 Token saved:', currentToken);
  } catch (error) {
    console.error('❌ Error retrieving/saving token:', error);
  }
};

// ONE foreground listener
if (messaging) {
  onMessage(messaging, (payload) => {
    console.log('🔔 Foreground message:', payload);
    if (Notification.permission === 'granted' && payload?.notification) {
      const { title, body } = payload.notification;
      new Notification(title || 'Canvas Sync', {
        body: body || 'You have an update',
        icon: '/logo192.png',
        data: payload?.data || {},
      });
    }
  });
}
